import { FC, useId } from "react";
interface DecorativeLineIconProps {
  width?: string | number;
  height?: string | number;
  className?: string;
}
/**
 * Componente de línea decorativa que combina 3 segmentos SVG:
 * Usa useId() para generar IDs únicos de filtros y gradientes,
 * permitiendo múltiples instancias en la misma página sin conflictos.
 */
export const IconDecorativeLine: FC<DecorativeLineIconProps> = ({
  className,
}) => {
  // 🔑 Genera un ID único para este componente
  const uniqueId = useId();
  // 🎨 Creamos IDs únicos para cada definición SVG
  const filterId = `filter-${uniqueId}`;
  const gradientId = `gradient-${uniqueId}`;
  return (
    <>
      {/* ========== SVG 1: Línea corta con gradiente ========== */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="3"
        viewBox="0 0 30 3"
        fill="none"
        className={className}
      >
        <g filter={`url(#${filterId})`}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.6899 3.07426H1.02379L0 0H29.6899V3.07426Z"
            fill={`url(#${gradientId})`}
          />
        </g>
        <defs>
          {/* Filtro con inner shadow */}
          <filter
            id={filterId}
            x="0"
            y="0"
            width="29.6895"
            height="3.07422"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="124" dy="64" />
            <feGaussianBlur stdDeviation="11.5" />
            <feComposite
              in2="hardAlpha"
              operator="arithmetic"
              k2="-1"
              k3="1"
            />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow"
            />
          </filter>
          {/* Gradiente de colores */}
          <linearGradient
            id={gradientId}
            x1="14.8449"
            y1="-0.268998"
            x2="14.8449"
            y2="3.65068"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#03A1C4" />
            <stop offset="0.47" stopColor="#683B97" />
            <stop offset="0.968322" stopColor="#03A1C4" />
          </linearGradient>
        </defs>
      </svg>
      {/* ========== SVG 2: Línea blanca media ========== */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="140"
        height="2"
        viewBox="0 0 140 2"
        fill="none"
        className={className}
      >
        <path
          d="M0 1.02475V0H204.758V1.02475H0Z"
          fill="white"
          fillOpacity="0.35"
        />
      </svg>
      {/* ========== SVG 3: Línea diagonal larga ========== */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="316"
        height="7"
        viewBox="0 0 316 7"
        fill="none"
        preserveAspectRatio="none"
        className={className}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 5V6H5.11689L16.0631 1H21.8925H973V0H21.8925H15.5594L4.61311 5H0Z"
          fill="white"
          fillOpacity="0.35"
        />
      </svg>
    </>
  );
};